import { render, staticRenderFns } from "./recapiti.vue?vue&type=template&id=34586569"
import script from "./recapiti.vue?vue&type=script&lang=js"
export * from "./recapiti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports